<template>
    <div>
        <div v-if="item.clientType === 'CORPORATE'">
            <v-icon size="small">mdi-account-tie</v-icon>
            <strong>
                {{ item.clientCompanyName }}
                <sup v-if="item.clientExtendedCRMPriority === 'VIP'" class="text-error">
                    {{ item.clientExtendedCRMPriority }}
                </sup>
                <v-icon v-else-if="item.clientExtendedCRMPriority === 'HIGH'" color="success" size="small">
                    mdi-arrow-up-thin
                </v-icon>
            </strong>
            <small v-if="item.tripOrganizer" class="d-block">
                {{
                    `${item.tripOrganizer?.prefix || ''} ${
                        item.tripOrganizer?.firstName || ''
                    } ${item.tripOrganizer?.lastName || ''}`
                }}
            </small>
        </div>
        <div v-else-if="item.clientType === 'DIRECT_SALES'">
            <v-icon size="small">mdi-account</v-icon>
            <strong>
                {{
                    `${item.clientPerson?.prefix || ''} ${
                        item.clientPerson?.firstName || ''
                    } ${item.clientPerson?.lastName || ''}`
                }}
                <sup v-if="item.clientExtendedCRMPriority === 'VIP'" class="text-error">
                    {{ item.clientExtendedCRMPriority }}
                </sup>
                <v-icon v-else-if="item.clientExtendedCRMPriority === 'HIGH'" color="success" size="small">
                    mdi-arrow-up-thin
                </v-icon>
            </strong>
        </div>
        <div v-else-if="item.clientType === 'TA'">
            <v-icon size="small">mdi-brightness-auto</v-icon>
            <strong>
                {{ item.clientCompanyName }}
                <sup v-if="item.clientExtendedCRMPriority === 'VIP'" class="text-error">
                    {{ item.clientExtendedCRMPriority }}
                </sup>
                <v-icon v-else-if="item.clientExtendedCRMPriority === 'HIGH'" color="success" size="small">
                    mdi-arrow-up-thin
                </v-icon>
            </strong>
            <small v-if="item.agent" class="d-block">
                {{ `${item.agent?.prefix || ''} ${item.agent?.firstName || ''} ${item.agent?.lastName || ''}` }}
            </small>
        </div>
    </div>
</template>

<script lang="ts">
    import {Component, Prop, Vue} from 'vue-facing-decorator'

    @Component
    export class OrdersClientLabel extends Vue {
        @Prop() item

        get isTourOperator() {
            return authStore.isTourOperator
        }

        get isAgency() {
            return authStore.isAgency
        }
    }

    export default OrdersClientLabel
</script>
